import { render, staticRenderFns } from "./breath.vue?vue&type=template&id=56b5b0d1&scoped=true&"
import script from "./breath.vue?vue&type=script&lang=js&"
export * from "./breath.vue?vue&type=script&lang=js&"
import style0 from "./breath.vue?vue&type=style&index=0&id=56b5b0d1&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5b0d1",
  null
  
)

export default component.exports